import React from 'react';
export function MainDifferencesSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-3470">
      <div className="bg-[#1874cd] py-4 px-6" data-id="element-3471">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-3472">
          The Main Difference Between Laser Cutting And Plasma Cutting
        </h2>
      </div>
      <div className="p-8 space-y-8" data-id="element-3473">
        <ul className="list-disc list-inside space-y-4 text-gray-700 text-lg leading-relaxed ml-4" data-id="element-3474">
          <li data-id="element-3475">
            Compared with plasma cutting machine, laser cutting machine has
            higher precision.
          </li>
          <li data-id="element-3476">
            The capital investment required for laser cutting machines is much
            higher than that of plasma cutting machines.
          </li>
          <li data-id="element-3477">
            Fiber laser cutting machines are most suitable for cutting thin
            metal sheets(≤25mm) and can cut all metal types.
          </li>
          <li data-id="element-3478">
            A plasma cutting machine is that it is suitable for cutting thick
            materials. It only needs to be cut without some beautiful shapes. If
            you need to cut some complete shapes, fiber laser cutting machines
            are better.
          </li>
        </ul>

        <div className="text-center pt-4" data-id="element-3479">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Plasma-vs-Laser.png" alt="Plasma vs Laser Cutting Comparison" className="block mx-auto w-full max-w-4xl h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-3480" />
        </div>
      </div>
    </div>;
}